/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ParsedEsaInfoModel } from '../models/ParsedEsaInfoModel';
import type { ParsedPrintersDto } from '../models/ParsedPrintersDto';
import type { ParsedServiceBoxModel } from '../models/ParsedServiceBoxModel';
import type { ParsedTechCaseModel } from '../models/ParsedTechCaseModel';
import type { ParsedTechCaseResponseModel } from '../models/ParsedTechCaseResponseModel';
import type { ParsedTyresInfoModel } from '../models/ParsedTyresInfoModel';
import type { VehicleEsaModel } from '../models/VehicleEsaModel';
import type { WebParsedRecallInfoModel } from '../models/WebParsedRecallInfoModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WebScrapingService {

  /**
   * Attempt to auth
   * @returns any Success
   * @throws ApiError
   */
  public static getWebScrapingSaveTableData(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/SaveTableData',
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static getWebScrapingUpdateBons(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/UpdateBons',
    });
  }

  /**
   * @param partNo 
   * @returns ParsedServiceBoxModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetPartInfoFromServiceBox(
partNo?: string,
): CancelablePromise<ParsedServiceBoxModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/GetPartInfoFromServiceBox',
      query: {
        'partNo': partNo,
      },
    });
  }

  /**
   * @param vin 
   * @param requestedUserId 
   * @param serviceBookingId 
   * @returns WebParsedRecallInfoModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetRecallInfo(
vin?: string,
requestedUserId?: number,
serviceBookingId?: number,
): CancelablePromise<Array<WebParsedRecallInfoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-recall-info',
      query: {
        'vin': vin,
        'requestedUserId': requestedUserId,
        'serviceBookingId': serviceBookingId,
      },
    });
  }

  /**
   * @param vin 
   * @param userId 
   * @param vehId 
   * @returns ParsedEsaInfoModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetEsaInfo(
vin?: string,
userId?: number,
vehId?: number,
): CancelablePromise<Array<ParsedEsaInfoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-esa-info',
      query: {
        'vin': vin,
        'userId': userId,
        'vehId': vehId,
      },
    });
  }

  /**
   * @param regNo 
   * @param userId 
   * @param isForced 
   * @returns VehicleEsaModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetEsaInfoForced(
regNo?: string,
userId?: number,
isForced?: boolean,
): CancelablePromise<VehicleEsaModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-esa-info-forced',
      query: {
        'regNo': regNo,
        'userId': userId,
        'isForced': isForced,
      },
    });
  }

  /**
   * @param regno 
   * @param userId 
   * @param isForced 
   * @returns VehicleEsaModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetEsaFile(
regno?: string,
userId?: number,
isForced: boolean = false,
): CancelablePromise<VehicleEsaModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-esa-file',
      query: {
        'regno': regno,
        'userId': userId,
        'isForced': isForced,
      },
    });
  }

  /**
   * @param userId 
   * @param driverLicenceNum 
   * @param nationalInsuranceNum 
   * @param postCode 
   * @returns string Success
   * @throws ApiError
   */
  public static getWebScrapingGetDriverInfo(
userId: number,
driverLicenceNum: string,
nationalInsuranceNum: string,
postCode: string,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-driver-info',
      query: {
        'UserId': userId,
        'DriverLicenceNum': driverLicenceNum,
        'NationalInsuranceNum': nationalInsuranceNum,
        'PostCode': postCode,
      },
    });
  }

  /**
   * @returns ParsedEsaInfoModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetDriversInfo(): CancelablePromise<Array<ParsedEsaInfoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-drivers-info',
    });
  }

  /**
   * @param regNo 
   * @param userId 
   * @returns ParsedTyresInfoModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetTyresInfo(
regNo?: string,
userId?: number,
): CancelablePromise<Array<ParsedTyresInfoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-tyres-info',
      query: {
        'regNo': regNo,
        'userId': userId,
      },
    });
  }

  /**
   * @param id 
   * @returns ParsedTechCaseModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetTechCase(
id?: number,
): CancelablePromise<Array<ParsedTechCaseModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-tech-case',
      query: {
        'id': id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postWebScrapingParseMfldVehicles(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/WebScraping/parse-mfld-vehicles',
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getWebScrapingGetMfldLastParsingDate(): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-mfld-last-parsing-date',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @returns ParsedPrintersDto Success
   * @throws ApiError
   */
  public static getWebScrapingGetBranchesPrintersStatus(): CancelablePromise<Array<ParsedPrintersDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-branches-printers-status',
    });
  }

  /**
   * @param id 
   * @returns ParsedPrintersDto Success
   * @throws ApiError
   */
  public static getWebScraping(
id: number,
): CancelablePromise<ParsedPrintersDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static putWebScraping(
id: number,
formData?: {
Id?: number;
BranchId?: number;
DeviceName?: string;
IPAddress?: string;
TonerStatus?: number;
TonerCartridgeCapacity?: number;
MaintenanceKitLifeRemaning?: number;
RollerKitLifeRemaning?: number;
ImagingUnitLifeRemaning?: number;
DateLastUpdate?: string;
DateCreate?: string;
Model?: number;
CartridgeNum?: string;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/WebScraping/{id}',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteWebScraping(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/WebScraping/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param formData 
   * @returns any Created
   * @throws ApiError
   */
  public static postWebScraping(
formData?: {
Id?: number;
BranchId?: number;
DeviceName?: string;
IPAddress?: string;
TonerStatus?: number;
TonerCartridgeCapacity?: number;
MaintenanceKitLifeRemaning?: number;
RollerKitLifeRemaning?: number;
ImagingUnitLifeRemaning?: number;
DateLastUpdate?: string;
DateCreate?: string;
Model?: number;
CartridgeNum?: string;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/WebScraping',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param vin 
   * @param wipNo 
   * @param branchId 
   * @param id 
   * @returns ParsedTechCaseResponseModel Success
   * @throws ApiError
   */
  public static getWebScrapingJobGetTechCase(
vin?: string,
wipNo?: number,
branchId?: number,
id?: number,
): CancelablePromise<ParsedTechCaseResponseModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/job-get-tech-case',
      query: {
        'vin': vin,
        'wipNo': wipNo,
        'branchId': branchId,
        'id': id,
      },
    });
  }

}
